"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_style["default"]);

var FormGroup = function FormGroup(_ref) {
  var children = _ref.children,
      appearance = _ref.appearance,
      direction = _ref.direction,
      indentation = _ref.indentation,
      border = _ref.border,
      centered = _ref.centered,
      label = _ref.label,
      caption = _ref.caption,
      action = _ref.action,
      tooltip = _ref.tooltip,
      rest = _objectWithoutProperties(_ref, ["children", "appearance", "direction", "indentation", "border", "centered", "label", "caption", "action", "tooltip"]);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, rest, {
    className: cx('xsui-form-group', "xsui-form-group--".concat(appearance), "xsui-form-group--direction-".concat(direction), "xsui-form-group--indentation-".concat(indentation), border && 'xsui-form-group--border', border && "xsui-form-group--border-".concat(border === true ? 'md' : border), centered && 'xsui-form-group--centered')
  }), label && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-form-group__label')
  }, void 0, label, tooltip && /*#__PURE__*/_jsx(_tooltip["default"], {
    label: tooltip,
    offset: "left"
  }), action && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-form-group__label__action')
  }, void 0, action)), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-form-group__entry')
  }, void 0, children), caption && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-form-group__caption')
  }, void 0, caption));
};

FormGroup.defaultProps = {
  appearance: 'primary',
  direction: 'column',
  indentation: 'md',
  border: false,
  centered: false,
  label: null,
  action: null,
  tooltip: null
};
var _default = FormGroup;
exports["default"] = _default;